import { render, staticRenderFns } from "./AgreementsFields.vue?vue&type=template&id=45f463d4&scoped=true&"
import script from "./AgreementsFields.vue?vue&type=script&lang=ts&"
export * from "./AgreementsFields.vue?vue&type=script&lang=ts&"
import style0 from "./AgreementsFields.vue?vue&type=style&index=0&id=45f463d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f463d4",
  null
  
)

export default component.exports